<template>
  <vjs-modal v-bind="$options.propsData"
             :title="title"
             icon="la la-link"
             width="500"
             :name="name">
    <template slot="body-content">
      <b-form class="assign-to-feed-modal-content" @submit.stop.prevent>
        <div class="form-group">
          <multiselect
            id="feed-select"
            v-model="the_feed"
            :options="feeds"
            placeholder="Select a feed"
            label="name"
            track-by="name" />
        </div>
      </b-form>
    </template>
    <template slot="body-controls">
      <b-button variant="ss-standout" :disabled="!the_feed" @click="() => close(true)">
        <loader v-if="waiting_callback" small class="mr-2" />
        Confirm
      </b-button>
      <b-button variant="ss" @click="() => close(false)">
        <loader v-if="waiting_callback" small class="mr-2" />
        Cancel
      </b-button>
    </template>
  </vjs-modal>
</template>

<script>
import VjsModal from 'VueModals/VjsModal';
import VjsModalMixin from 'VueModals/VjsModalMixin';
import { nullish } from 'Lib/type-sanity';

export default {
  name: `assign-to-feed-modal`,
  components: {
    VjsModal,
  },
  mixins: [VjsModalMixin],
  asyncComputed: {
    feeds: {
      async get() {
        return (await axios.get(`/api/v1/feeds`)).data.data;
      },
      default: [],
    },
  },
  props: {
    name: {
      type: String,
      required: false,
      default: `assign-to-feed-modal`,
    },
    title: {
      type: String,
      required: false,
      default: `Assign to Feed:`,
    },
  },
  data: () => ({
    the_feed: null,
  }),
  methods: {
    close(confirmed) {
      this.close_data.confirm = confirmed;
      this.close_data.feed = this.the_feed;
      this.complete();
      this.the_feed = null;
    },
    nullish,
  },
};
</script>

<style lang="scss" scoped>
:deep(.multiselect__content-wrapper) {
  position: static;
  border-bottom: 1px solid #e8e8e8;
}
</style>
